import React, { useState, useEffect } from 'react';
import QuestionTemplateManager from './QuestionTemplateManager.jsx';

const DEFAULT_ADHOC_TEMPLATE = [];
// This mock function is needed to satisfy the prop requirements of QuestionTemplateManager, 
// but it won't actually fetch anything since ad-hoc questions start empty.
const MOCK_GET_TEMPLATE_FN = () => Promise.resolve(DEFAULT_ADHOC_TEMPLATE);
// This mock function is needed to satisfy the prop requirements, but we use the parent state 
// for saving the final template data, not a direct save call here.
const MOCK_SAVE_TEMPLATE_FN = () => Promise.resolve(true); 

// We don't need system status for an in-memory component
const MOCK_GET_SYSTEM_STATUS_FN = () => Promise.resolve({ 
  database_status: 'OK', 
  message: 'Local template manager is always online.' 
});


const AdHocQuestionManager = ({ onQuestionsChange }) => {
  const [adhocTemplate, setAdhocTemplate] = useState([]);

  // This internal function replicates the QuestionTemplateManager's saving logic 
  // without calling the API, returning the formatted template data.
  const getCleanTemplateData = (template) => {
    // Filter out temporary negative IDs and 'change_type' (since they're all 'new'/'unchanged' initially)
    return template
        // Only include questions that have text (ignore empty lines/headings)
        .filter(q => q.text.trim() !== '')
        .map(q => {
            const newQ = { ...q };
            // Ensure temporary IDs are removed for brand new questions
            if (newQ.id < 0) {
              delete newQ.id;
            }
            // Remove unnecessary state flags for submission
            delete newQ.change_type;
            delete newQ.id; // Ensure no ID is sent, as they are all new
            return newQ;
        });
  };

  // When the internal template changes, notify the parent component (DeploySurvey)
  useEffect(() => {
    if (onQuestionsChange) {
      // 1. Get the cleaned array of question objects
      const cleanData = getCleanTemplateData(adhocTemplate);

      // 2. map the objects to their text and join them with newlines <<<
      const adhocTextString = cleanData.map(q => q.text).join('\n');
      
      // Pass the final text string
      onQuestionsChange(adhocTextString); 
    }
  }, [adhocTemplate, onQuestionsChange]);


  return (
    <QuestionTemplateManager
      title="One-Time Questions"
      description="Add temporary questions that will be merged into the survey for this deployment only. These questions are saved for the current deployment request, not for future use."
      getTemplateFn={MOCK_GET_TEMPLATE_FN}
      saveTemplateFn={MOCK_SAVE_TEMPLATE_FN}
      getSystemStatusFn={MOCK_GET_SYSTEM_STATUS_FN}
      defaultTemplate={DEFAULT_ADHOC_TEMPLATE}
      templateType="adhoc"
      onTemplateUpdate={setAdhocTemplate} 
      hideSaveButton={true}      
    />
  );
};

export default AdHocQuestionManager;